import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import BookingService from './../../../../services/cargobooking.service';
import Util from './../../../../../shared/util/util';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'abfrlbookinglogs',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CustomExpandableTable,
    Treeselect
  },
  data: function() {
    return {
      tableColumn:['AWB Number','Shipper Name','#MPS','Pickup Date','Created Date','Last Modified Date','Processed','Error','Comment'],
      tableItems:[],
      awbNoSearch:'',
      AWBNumber:'',
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      userName:'',
      pageLimit:CONSTANT.PER_PAGE_DATA,
      YesorNoOptions:[
        {id:'1',label:'Yes'},
        {id:'0',label:'No'},
      ],
      Processed: null,
      Error: null,
      CreatedFromDateSearch:'',
      CreatedToDateSearch:''
    }
  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    await this.getabfrlsummarydata();
    this.isLoading = false;
 },
  methods:{
  onPageChange(page) {
    this.currentPage = page;
    this.offset = (page - 1) * this.pageLimit
    this.getabfrlsummarydata();
  },
  searchFilter(){
    this.currentPage = 1;
    this.offset = 0;
    this.getabfrlsummarydata();
  },
  resetSearch(){
    this.AWBNumber='';
    this.Processed=null;
    this.Error=null;
    this.CreatedFromDateSearch='';
    this.CreatedToDateSearch='';
    this.getabfrlsummarydata();
  },
  async getabfrlsummarydata(){
    try {
      this.isLoading = true;
      let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
      }
      if(this.AWBNumber!=""){
        inputPayload.awbnumber = this.AWBNumber;
      }
      if(this.Processed){
        inputPayload.processed = this.Processed;
      }
      if(this.Error){
        inputPayload.error = this.Error;
      }
      if(this.CreatedFromDateSearch!=''){
        inputPayload.createdfromdate = Util.DateOnlyFormat(this.CreatedFromDateSearch);
      }
      if(this.CreatedToDateSearch!=''){
        inputPayload.createdtodate = Util.DateOnlyFormat(this.CreatedToDateSearch);
      }
      let result = await BookingService.GetAbfrlSummaryData(inputPayload)
      //let result = allResolved[0]
      this.tableArr = result.data.data.rows;
      this.totalCount = result.data.data.count;
      if(this.totalCount>0){
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id': el.lrnumbers,
            'AWB Number': el.lrnumbers,
            'Shipper Name' : el.shippername,
            '#MPS' : el.npscount,
            'Pickup Date': Util.displayDateOnlyFormat(el.pudate),
            'Created Date': Util.displayDateTimeFormat(el.systemcreateddate),
            'Last Modified Date':Util.displayDateTimeFormat(el.systemlastmodifieddate),
            'Processed':(el.processed == 0)?"No":"Yes",
            'Error':(el.error == 0)?"No":"Yes",
            'Comment':el.comment,
          }
        })
      }else{
        this.tableItems = [];
      }
      if (this.totalCount < this.pageLimit) {
        this.totalPage = 1
      } else {
        this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
      }
      this.isLoading = false;
      }
      catch(err){
      console.log(err);
      this.isLoading = false;
    }
  },

  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/abfrlLogs/abfrlbookinglogs/abfrlbookinglogs.component.js